import React from "react";
import { Box, Typography, Button } from "@mui/material";

const NotFound = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      sx={{
        backgroundColor: "#1a1a1a", // Dark background for the page
        textAlign: "center",
        padding: 2,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Animated background circle */}
      <Box
        sx={{
          position: "absolute",
          width: "200px",
          height: "200px",
          borderRadius: "50%",
          backgroundColor: "#5858E0",
          top: "-50%",
          left: "-50%",
          animation: "moveCircle 5s ease-in-out infinite",
        }}
      ></Box>

      {/* Blurry and floating 404 */}
      <Typography
        sx={{
          fontSize: "120px",
          fontWeight: 700,
          color: "#f39c12",
          animation: "floatText 3s ease-in-out infinite",
          zIndex: 1,
          marginBottom: 2,
        }}
      >
        404
      </Typography>

      <Typography
        sx={{
          fontSize: "60px",
          fontWeight: 700,
          color: "#FF0000",
          animation: "floatText 3s ease-in-out infinite",
          zIndex: 1,
          marginBottom: 2,
        }}
      >
        Page Not Found
      </Typography>

      {/* Page not found message */}
      <Typography
        sx={{
          fontSize: "24px",
          color: "#ecf0f1",
          animation: "fadeIn 2s ease-in-out",
          marginBottom: 3,
          zIndex: 1,
        }}
      >
        Oops! This page doesn't exist.
      </Typography>

      {/* Inline CSS for animations */}
      <style>
        {`
          @keyframes floatText {
            0% {
              transform: translateY(-10px);
            }
            50% {
              transform: translateY(10px);
            }
            100% {
              transform: translateY(-10px);
            }
          }

          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes moveCircle {
            0% {
              top: -50%;
              left: -50%;
            }
            25% {
              top: 50%;
              left: 50%;
            }
            50% {
              top: -50%;
              left: 50%;
            }
            75% {
              top: 50%;
              left: -50%;
            }
            100% {
              top: -50%;
              left: -50%;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default NotFound;
